import {
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  PKBDruckdaten,
  SparteDruckdaten,
  SpartenType,
  VertreterWechselDruck,
} from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { getSpartenTypeByApp, getTarifbereich } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../localStore';
import { getProgrammteilnahme } from '../../model/policeVersandArt';
import { getBeziehungVpZumVn } from '../druckenSaga.helper';
import {
  addCheckoutDataToSparteDruckdaten,
  mapAntraege,
  mapBankverbindung,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';
import { mapJagdschein } from './jagdbestaetigung.mapper';

export function mapPKB(
  state: IAppState,
  sparteDruckdaten: SparteDruckdaten,
  vertreterWechselDruckDaten: Array<VertreterWechselDruck>,
): DokumentenErstellungRequestModel<PKBDruckdaten> {
  const commonPKBdaten: DokumentenErstellungRequestModel<PKBDruckdaten> = {
    antraege: mapAntraege([sparteDruckdaten]),
    sammelantragsnummer: state.sammelantragsnummer,
    bankverbindung: mapBankverbindung(state),
    vermittler: mapVermittler(state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    vertragsschlussverfahren: state.vertragsschlussverfahren,
    zahlungsmethode: {
      zahlungsart: state.zahlung.zahlungsart,
      zahlweise: state.zahlung.zahlweise,
    },
    dokumentDruckdaten: {
      dokument: BffDokument.PKB,
      uebergabeVertragsschlussverfahren: state.telefonverkauf.versandArtAVB,
      rdb: mapRdbAktuell(sparteDruckdaten),
      effectiveZaehlstuecke: state.effectiveZaehlstuecke,
      unfallZaehlstuecke: state.unfallZaehlstuecke,
      programmteilnahme: getProgrammteilnahme(state.policeVersand.versandArt),
      jagdschein: mapJagdschein(state),
      vertreterWechselDruckDaten,
    },
    tarifbereich: getTarifbereich(
      state.versicherungsnehmer,
      getBeziehungVpZumVn(state, sparteDruckdaten),
    ),
    fernabsatz: state.fernabsatz ?? undefined,
  };
  const clonedPKBRequest: DokumentenErstellungRequestModel<PKBDruckdaten> =
    cloneDeep(commonPKBdaten);
  clonedPKBRequest.sparteDruckdaten = addCheckoutDataToSparteDruckdaten(state, sparteDruckdaten);

  handleSofortschutzFromContractInformation(state, clonedPKBRequest);
  return clonedPKBRequest;
}

function mapRdbAktuell(sparteDruckdaten: SparteDruckdaten): number {
  return sparteDruckdaten.rbdAktuell;
}

export function mapVermittlerWechselDaten(
  spartenDruckdaten: Array<SparteDruckdaten>,
): Array<VertreterWechselDruck> {
  return spartenDruckdaten
    .filter(sparte => {
      return sparte.vorvertragsnummern?.some(vv => vv.isVertreterWechsel);
    })
    ?.map(
      spartenDruckdaten =>
        ({
          spartenType: spartenDruckdaten.spartenType,
          antragsnummer: spartenDruckdaten.antragsnummer,
        }) as VertreterWechselDruck,
    );
}

function handleSofortschutzFromContractInformation(
  state: IAppState,
  clonedPKBRequest: DokumentenErstellungRequestModel<PKBDruckdaten>,
): void {
  const produkt = state.produkte.find(
    produkt =>
      produkt.angebotsId === clonedPKBRequest.sparteDruckdaten.angebotsId &&
      getSpartenTypeByApp(produkt.appId) === clonedPKBRequest.sparteDruckdaten.spartenType,
  );
  if (
    produkt &&
    Boolean(produkt.vorvertragSofortschutzAblaufDatum) &&
    clonedPKBRequest.sparteDruckdaten.spartenType !== SpartenType.WOHNGEBAEUDE &&
    clonedPKBRequest.sparteDruckdaten.spartenType !== SpartenType.WOHNGEBAEUDE_V2
  ) {
    clonedPKBRequest.sparteDruckdaten.isSofortschutzActive = Boolean(
      produkt.vorvertragSofortschutzAblaufDatum,
    );
    clonedPKBRequest.sparteDruckdaten.sofortschutzEndeDatum =
      produkt.vorvertragSofortschutzAblaufDatum;
  }
}
